import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'

export const NavLogo = styled(LinkR)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    @media screen and (max-width: 768px) {
        margin-left: -100px;
    }
`
export const NavLogo_catering = styled(LinkR)`
    color: #fff;
    align-items: center;
    text-decoration: none;
    height: 100%;
    cursor: pointer;
`
export const SliderBtn = styled(LinkR)`
    cursor: pointer;
`

export const FooterR = styled(LinkR)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    margin-left: -15px;

    
`

export const NavLinks = styled(LinkS)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
`